const updateCartCountBadge = (itemCount) => {
  const count = Number(itemCount || 0);

  document.querySelectorAll('[data-cart-count-badge]').forEach((badge) => {
    badge.hidden = count <= 0;
    badge.textContent = count > 99 ? '99+' : String(count);
  });
};

const refreshCartCountBadge = async () => {
  try {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) return;

    const cart = await response.json();
    updateCartCountBadge(cart.item_count);
  } catch (error) {
    // The cart page still reflects the correct count after a normal reload.
  }
};

document.addEventListener('cart:refresh', refreshCartCountBadge);

const loginReturnStorageKey = 'pit_login_return_url';
const buildAccountLoginUrl = (returnUrl) => {
  const loginUrl = new URL('/account/login', window.location.origin);
  if (returnUrl && returnUrl.startsWith('/')) {
    loginUrl.searchParams.set('return_url', returnUrl);
  }
  return `${loginUrl.pathname}${loginUrl.search}`;
};

document.addEventListener('click', (event) => {
  const returnLink = event.target.closest('[data-login-return-source]');
  const loginLink = event.target.closest('a[href*="/account/login"], a[href*="/authentication/"]');
  if (!returnLink && !loginLink) return;

  try {
    if (returnLink) {
      const returnUrl = returnLink.dataset.loginReturnUrl || `${window.location.pathname}${window.location.search}`;
      localStorage.setItem(loginReturnStorageKey, returnUrl);
      return;
    }

    if (loginLink && window.location.pathname === '/pages/register-application') {
      const savedReturnUrl = localStorage.getItem(loginReturnStorageKey);
      if (savedReturnUrl) return;
    }
  } catch (error) {
    // Login still works even when browser storage is unavailable.
  }
});

document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === '/pages/register-application') {
    const params = new URLSearchParams(window.location.search);
    const returnTo = params.get('return_to');

    if (returnTo && returnTo.startsWith('/products/')) {
      try {
        localStorage.setItem(loginReturnStorageKey, returnTo);
      } catch (error) {
        // Login still works even when browser storage is unavailable.
      }

      document.querySelectorAll('a[href*="/account/login"]').forEach((link) => {
        link.href = buildAccountLoginUrl(returnTo);
      });
    }
  }

  const isAccountLandingPage =
    window.location.pathname.startsWith('/pages/mypage') ||
    window.location.pathname.startsWith('/account') ||
    window.location.pathname.includes('/account/orders');

  if (!isAccountLandingPage) return;

  let returnUrl = '';
  try {
    returnUrl = localStorage.getItem(loginReturnStorageKey) || '';
    localStorage.removeItem(loginReturnStorageKey);
  } catch (error) {
    returnUrl = '';
  }

  if (!returnUrl || returnUrl === window.location.pathname) return;
  window.location.replace(returnUrl);
});

document.addEventListener('DOMContentLoaded', () => {
  const sampleLimitNotice = document.querySelector('[data-sample-limit-notice]');
  if (!sampleLimitNotice) return;

  const params = new URLSearchParams(window.location.search);
  if (params.get('sample_limit') === '1') {
    sampleLimitNotice.hidden = false;
  }
});

document.addEventListener('change', (event) => {
  const target = event.target;
  if (!(target instanceof HTMLSelectElement)) return;
  if (target.matches('[data-variant-option]')) {
    const picker = target.closest('[data-variant-picker]');
    const variantsJson = document.querySelector('[data-product-variants-json]');
    const variantInput = document.querySelector('[data-variant-id-input]');

    if (!picker || !variantsJson || !variantInput) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsJson.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const selectedOptions = Array.from(picker.querySelectorAll('[data-variant-option]')).map((select) => select.value);
    const selectedVariant = variants.find((variant) => {
      return selectedOptions.every((optionValue, index) => variant.options[index] === optionValue);
    });

    if (selectedVariant) {
      variantInput.value = selectedVariant.id;

      const productAddButton = document.querySelector('[data-product-add-button]');
      if (productAddButton) {
        productAddButton.disabled = !selectedVariant.available;
        productAddButton.textContent = selectedVariant.available ? '製品を購入' : '製品在庫切れ';
      }
    }

    return;
  }

  if (!target.matches('[data-leadtime-selector]')) return;

  const option = target.selectedOptions[0];
  const root = target.closest('[data-leadtime-root]');
  if (!root || !option) return;

  const leadtime = root.querySelector('[data-leadtime-value]');
  const shipping = root.querySelector('[data-shipping-value]');
  const total = root.querySelector('[data-total-estimate]');
  const productPrice = Number(root.getAttribute('data-product-price') || '0');
  const shippingFee = Number(option.getAttribute('data-shipping-fee') || '0');

  if (leadtime) leadtime.textContent = option.getAttribute('data-leadtime') || '-';
  if (shipping) shipping.textContent = shippingFee ? `${shippingFee.toLocaleString()}円` : '-';
  if (total && root.hasAttribute('data-product-price')) {
    total.textContent = (productPrice + shippingFee).toLocaleString() + '円';
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;

  const sampleMarker = form.querySelector('[data-sample-add-marker]');
  if (sampleMarker) {
    const sampleVariantId = Number(sampleMarker.getAttribute('data-sample-variant-id') || '0');

    if (!sampleVariantId) return;
    event.preventDefault();

    try {
      const response = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) {
        HTMLFormElement.prototype.submit.call(form);
        return;
      }

      const cart = await response.json();
      const alreadyInCart = Array.isArray(cart.items) && cart.items.some((item) => Number(item.variant_id) === sampleVariantId);

      if (alreadyInCart) {
        let sampleLimitUrl = '/cart?sample_limit=1';

        try {
          const limitPage = await fetch('/pages/sample-limit', { method: 'HEAD' });
          if (limitPage.ok) sampleLimitUrl = '/pages/sample-limit';
        } catch (error) {
          sampleLimitUrl = '/cart?sample_limit=1';
        }

        window.location.href = sampleLimitUrl;
        return;
      }
    } catch (error) {
      // If the cart cannot be checked, Shopify's cart validation still enforces the limit.
    }

    HTMLFormElement.prototype.submit.call(form);
    return;
  }

  if (!form.matches('[data-ajax-add-to-cart]')) return;

  event.preventDefault();

  const button = form.querySelector('.product-card__cart-button');
  const defaultText = button ? button.textContent.trim() : '';

  if (button) {
    button.disabled = true;
    button.classList.remove('is-added');
    button.textContent = '追加中...';
  }

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json'
      },
      body: new FormData(form)
    });

    if (!response.ok) throw new Error('Cart add failed');

    if (button) {
      button.classList.add('is-added');
      button.textContent = '追加しました';
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));

    window.setTimeout(() => {
      if (!button) return;
      button.disabled = false;
      button.classList.remove('is-added');
      button.textContent = defaultText || 'カートに入れる';
    }, 1400);
  } catch (error) {
    if (button) {
      button.textContent = '追加できませんでした';
      window.setTimeout(() => {
        button.disabled = false;
        button.textContent = defaultText || 'カートに入れる';
      }, 1800);
    }
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const lineQrModal = document.querySelector('[data-line-qr-modal]');
  const openLineQrModal = () => {
    if (!lineQrModal) return;
    lineQrModal.hidden = false;
    document.documentElement.classList.add('line-qr-modal-open');
    const closeButton = lineQrModal.querySelector('[data-line-qr-close]');
    if (closeButton instanceof HTMLElement) closeButton.focus({ preventScroll: true });
  };
  const closeLineQrModal = () => {
    if (!lineQrModal) return;
    lineQrModal.hidden = true;
    document.documentElement.classList.remove('line-qr-modal-open');
  };

  document.querySelectorAll('[data-line-qr-open]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      openLineQrModal();
    });
  });

  document.querySelectorAll('[data-line-qr-close]').forEach((trigger) => {
    trigger.addEventListener('click', closeLineQrModal);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && lineQrModal && !lineQrModal.hidden) closeLineQrModal();
  });

  if (window.location.pathname === '/pages/about') {
    const lineLinks = Array.from(document.querySelectorAll('a')).filter((link) => {
      const label = `${link.textContent || ''} ${link.getAttribute('aria-label') || ''}`;
      return label.includes('LINEで相談');
    });
    const targetLink = lineLinks[lineLinks.length - 1];

    if (targetLink) {
      const lineQrImage = lineQrModal ? lineQrModal.querySelector('.line-qr-modal__image') : null;
      const lineQrSrc = lineQrImage instanceof HTMLImageElement ? lineQrImage.currentSrc || lineQrImage.src : '';
      const qrBlock = document.createElement('div');
      qrBlock.className = 'line-qr-about-block';
      qrBlock.innerHTML = `
        <img class="line-qr-about-block__image" src="${lineQrSrc}" alt="LINE公式アカウントのQRコード" loading="lazy">
        <p class="line-qr-about-block__text">お友達に追加してお問い合わせください。</p>
      `;
      targetLink.replaceWith(qrBlock);
    }
  }

  document.querySelectorAll('[data-randomize-products]').forEach((grid) => {
    const cards = Array.from(grid.children);
    if (cards.length < 2) return;

    cards
      .sort(() => Math.random() - 0.5)
      .forEach((card) => grid.appendChild(card));
  });

  const currentProduct = document.querySelector('[data-current-product]');
  const recentProductsSections = Array.from(document.querySelectorAll('[data-recent-products-section]'));
  const storageKey = 'cookpit_recent_products_v1';
  let recentProducts = [];

  try {
    recentProducts = JSON.parse(localStorage.getItem(storageKey) || '[]');
  } catch (error) {
    recentProducts = [];
  }

  if (currentProduct) {
    const productData = {
      id: currentProduct.getAttribute('data-product-id') || '',
      title: currentProduct.getAttribute('data-product-title') || '',
      url: currentProduct.getAttribute('data-product-url') || window.location.pathname,
      image: currentProduct.getAttribute('data-product-image') || '',
      hoverImage: currentProduct.getAttribute('data-product-hover-image') || '',
      category: currentProduct.getAttribute('data-product-category') || '',
      maker: currentProduct.getAttribute('data-product-maker') || '',
      price: currentProduct.getAttribute('data-product-price') || ''
    };

    if (productData.id && productData.title) {
      recentProducts = [
        productData,
        ...recentProducts.filter((item) => item && item.id !== productData.id)
      ].slice(0, 10);

      try {
        localStorage.setItem(storageKey, JSON.stringify(recentProducts));
      } catch (error) {
        recentProducts = recentProducts.slice(0, 5);
      }
    }
  }

  recentProductsSections.forEach((recentProductsSection) => {
    const recentProductsGrid = recentProductsSection.querySelector('[data-recent-products-grid]');
    if (!recentProductsGrid) return;

    recentProductsGrid.innerHTML = '';

    recentProducts.slice(0, 10).forEach((item) => {
      if (!item || !item.title || !item.url) return;

      const card = document.createElement('article');
      card.className = 'product-card card';

      const link = document.createElement('a');
      link.href = item.url;

      const image = document.createElement('div');
      image.className = 'product-card__image product-card__image--blank';

      if (item.image) {
        const img = document.createElement('img');
        img.src = item.image;
        img.alt = item.title;
        img.loading = 'lazy';
        img.className = 'product-card__image-primary';
        image.appendChild(img);
      }

      if (item.hoverImage) {
        const hoverImg = document.createElement('img');
        hoverImg.src = item.hoverImage;
        hoverImg.alt = item.title;
        hoverImg.loading = 'lazy';
        hoverImg.className = 'product-card__image-hover';
        image.appendChild(hoverImg);
      }

      const body = document.createElement('div');
      body.className = 'product-card__body';

      const title = document.createElement('h3');
      title.className = 'product-card__title';
      title.textContent = item.title;
      body.appendChild(title);

      if (item.maker) {
        const maker = document.createElement('p');
        maker.className = 'product-card__maker';
        maker.textContent = item.maker;
        body.appendChild(maker);
      }

      if (item.price) {
        const price = document.createElement('p');
        price.className = 'product-card__price';
        price.textContent = item.price;
        body.appendChild(price);
      }

      link.append(image, body);
      card.appendChild(link);
      recentProductsGrid.appendChild(card);
    });

    if (recentProductsGrid.children.length > 0) {
      recentProductsSection.hidden = false;
    }
  });

  if (!window.matchMedia('(max-width: 767px)').matches) return;

  document.querySelectorAll('.product-accordion[open]').forEach((accordion) => {
    accordion.removeAttribute('open');
  });

  document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
    let startX = 0;
    let startY = 0;

    gallery.addEventListener('touchstart', (event) => {
      const touch = event.touches[0];
      if (!touch) return;
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      const touch = event.changedTouches[0];
      if (!touch) return;

      const diffX = touch.clientX - startX;
      const diffY = touch.clientY - startY;
      if (Math.abs(diffX) < 45 || Math.abs(diffX) < Math.abs(diffY)) return;

      const control = gallery.querySelector(diffX < 0 ? '[data-gallery-next]' : '[data-gallery-prev]');
      if (control) control.click();
    }, { passive: true });
  });
});

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  const variantOptionCard = target.closest('[data-variant-option-card]');
  if (variantOptionCard) {
    const picker = variantOptionCard.closest('[data-variant-picker]');
    const optionPosition = variantOptionCard.getAttribute('data-option-position');
    const optionValue = variantOptionCard.getAttribute('data-option-value');
    const select = picker && optionPosition
      ? picker.querySelector(`[data-variant-option][data-option-position="${optionPosition}"]`)
      : null;

    if (!picker || !select || !optionValue) return;

    select.value = optionValue;
    picker.querySelectorAll(`[data-variant-option-card][data-option-position="${optionPosition}"]`).forEach((card) => {
      const isActive = card === variantOptionCard;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-pressed', String(isActive));
    });
    select.dispatchEvent(new Event('change', { bubbles: true }));
    return;
  }

  const sampleFilterButton = target.closest('[data-sample-filter]');
  if (sampleFilterButton) {
    const filter = sampleFilterButton.getAttribute('data-sample-filter') || 'all';
    const tabs = sampleFilterButton.closest('[data-sample-filter-tabs]');
    const collectionSection = sampleFilterButton.closest('.collection-products-section');
    const sampleCards = collectionSection ? Array.from(collectionSection.querySelectorAll('[data-sample-card]')) : [];

    if (tabs) {
      tabs.querySelectorAll('[data-sample-filter]').forEach((button) => {
        button.classList.toggle('ranking-tabs__item--active', button === sampleFilterButton);
      });
    }

    sampleCards.forEach((card) => {
      const groups = (card.getAttribute('data-sample-groups') || '').split(/\s+/);
      card.hidden = filter !== 'all' && !groups.includes(filter);
    });
    return;
  }

  const menuToggle = target.closest('[data-mobile-menu-toggle]');
  if (menuToggle) {
    const header = menuToggle.closest('.site-header__inner');
    const panel = header ? header.querySelector('[data-mobile-menu-panel]') : null;
    if (!panel) return;

    const isOpen = panel.classList.toggle('is-open');
    menuToggle.setAttribute('aria-expanded', String(isOpen));
    menuToggle.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
    return;
  }

  document.querySelectorAll('[data-mobile-menu-panel].is-open').forEach((panel) => {
    if (panel.contains(target)) return;
    const header = panel.closest('.site-header__inner');
    const toggle = header ? header.querySelector('[data-mobile-menu-toggle]') : null;
    panel.classList.remove('is-open');
    if (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'メニューを開く');
    }
  });

  const galleryControl = target.closest('[data-gallery-prev], [data-gallery-next], [data-gallery-thumb]');
  if (galleryControl) {
    const gallery = galleryControl.closest('[data-product-gallery]');
    if (!gallery) return;

    const mainMedia = gallery.querySelector('[data-gallery-main-media]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!mainMedia || thumbs.length === 0) return;

    const currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    let nextIndex = currentIndex;

    if (galleryControl.matches('[data-gallery-prev]')) {
      nextIndex = currentIndex <= 0 ? thumbs.length - 1 : currentIndex - 1;
    } else if (galleryControl.matches('[data-gallery-next]')) {
      nextIndex = currentIndex >= thumbs.length - 1 ? 0 : currentIndex + 1;
    } else {
      nextIndex = thumbs.indexOf(galleryControl);
    }

    const nextThumb = thumbs[nextIndex];
    if (!nextThumb) return;

    const mediaIndex = nextThumb.getAttribute('data-gallery-media-index') || nextThumb.getAttribute('data-gallery-index');
    const mediaTemplate = mediaIndex ? gallery.querySelector(`[data-gallery-media-template][data-gallery-index="${mediaIndex}"]`) : null;

    const caption = gallery.querySelector('[data-gallery-caption]');
    const nextCaption = nextThumb.getAttribute('data-gallery-caption') || '';

    if (mediaTemplate) {
      mainMedia.innerHTML = mediaTemplate.innerHTML;
    } else {
      const nextImage = nextThumb.getAttribute('data-gallery-image');
      if (!nextImage) return;
      mainMedia.innerHTML = `<img src="${nextImage}" alt="${nextThumb.getAttribute('data-gallery-alt') || ''}">`;
    }
    if (caption) {
      caption.textContent = nextCaption;
      caption.hidden = !nextCaption;
    }
    thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === nextThumb));
    return;
  }

  const button = target.closest('[data-quantity-minus], [data-quantity-plus]');
  if (!button) return;

  const stepper = button.closest('[data-quantity-stepper]');
  if (!stepper) return;

  const input = stepper.querySelector('input[type="number"]');
  if (!input) return;

  const min = Number(input.getAttribute('min') || '1');
  const current = Number(input.value || min);
  const next = button.matches('[data-quantity-minus]') ? current - 1 : current + 1;
  input.value = String(Math.max(min, next));
  input.dispatchEvent(new Event('change', { bubbles: true }));
});
